import { getRouteApi } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'

const rootApi = getRouteApi('__root__')

// The hook IS the context access: ~60 components read the session and would each repeat the getRouteApi.
export function useSessionUser() {
  return useSessionUserQuery().data
}

// Anything that REDIRECTS off the user's flags must wait out isFetching; `data` alone can be a pre-write snapshot.
export function useSessionUserQuery() {
  return useSuspenseQuery(rootApi.useRouteContext().sessionUserQueryOptions)
}
